// HEX values pulled from Figma (Catalight Report Submission, node 148:4221).
// Hardcoded for now; once the design tokens for these subtle/onsubtle pairs land
// in Mosaic we should swap to those.
const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  Draft: { bg: "rgba(61,58,52,0.08)", text: "#3d3a34" },
  Complete: { bg: "#d0e4ff", text: "#030e24" },
  Submitted: { bg: "#f1dcff", text: "#1e082a" },
  "Needs Revision": { bg: "#fdebd4", text: "#2c1302" },
  Approved: { bg: "#dbf5df", text: "#052a1c" },
};

// Fallback for non-lifecycle status values (e.g., "Import Failed", legacy IA
// granular labels). Keeps the same shape as the spec'd badges so layout is
// consistent across the table.
const FALLBACK = { bg: "rgba(61,58,52,0.08)", text: "#3d3a34" };

interface StatusTagProps {
  status: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const { bg, text } = STATUS_COLORS[status] ?? FALLBACK;
  return (
    <span
      className="inline-flex max-h-6 min-w-fit items-center rounded-md px-2 py-1 text-xs font-medium"
      style={{ backgroundColor: bg, color: text }}
    >
      {status}
    </span>
  );
};
